import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import blood from "../../Assets/Projects/bloodbanksystem.png";
import hotel from "../../Assets/Projects/hotelbooking.png";
import hiring from "../../Assets/Projects/hiringweb.png";
import adminpanel from "../../Assets/Projects/adminpanel.png";
import hosting from "../../Assets/Projects/hosting.png";
import chatbot from "../../Assets/Projects/Chat.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={hotel}
              isBlog={false}
              title="Hotel Booking Website"
              description="“Online Hotel Booking” is the project that is used for the online hotel reservation. User book the hotel by visiting the Hotel website. Technologies used in this Project, are PHP, MySQL"
              ghLink="https://github.com/mubashar-nouman/hotel-booking-website"
              demoLink="https://github.com/mubashar-nouman/hotel-booking-website"
            />
          </Col>



          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={blood}
              isBlog={false}
              title="Blood Management System"
              description="This is a desktop application for blood bank management system. It is developed using C# ASP .NET MVC and MySQL. It is a simple application that can be used to manage blood bank."
              ghLink="https://github.com/mubashar-nouman/blood-bank-management-system-c-"
              demoLink="https://github.com/mubashar-nouman/blood-bank-management-system-c-"
            />
          </Col>



          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={hiring}
              isBlog={false}
              title="Hiring Website Frontend"
              description="This is the website to hire video editors. It is developed using HTML, CSS, Bootstrap, JavaScript. It is a simple website that can be used to hire video editors."
              ghLink="https://github.com/mubashar-nouman/food-website-htmlcss"
              demoLink="https://github.com/mubashar-nouman/food-website-htmlcss"              
            />
          </Col>



          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={adminpanel}
              isBlog={false}
              title="Ecommerce Admin Panel"
              description="This is the admin panel for ecommerce website. It is developed using HTML, CSS, Ant Design & React. It is a simple website that can be used to manage ecommerce website."
              ghLink="https://github.com/mubashar-nouman/Corner-Store"
              demoLink="https://github.com/mubashar-nouman/Corner-Store"
            />
          </Col>



          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatbot}
              isBlog={false}
              title="Doctor Chatbot"
              description="This is the doctor chatbot developed using NLP & ML. It is a simple website that can be used to diagnose different diseases. It will also provide the prescription of the disease."
              ghLink="https://github.com/mubashar-nouman/FYP-1"
              demoLink="https://github.com/mubashar-nouman/FYP-1"
            />
          </Col>



          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={hosting}
              isBlog={false}
              title="Hosting Provider Web"
              description="This is the hosting provider website frontend. It will be used to showcase different hosting and domain plans for different websites. Developes using HTML & CSS only."
              ghLink="https://github.com/mubashar-nouman/domain-site"
              demoLink="https://github.com/mubashar-nouman/domain-site"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
